import { useQueryClient } from 'react-query';
import { QUERIES_INFO } from '@shared';
export const useIsUserAuthorized = () => {
  const queryClient = useQueryClient();
  const queryResponse = queryClient.getQueryData(QUERIES_INFO.currentUser.key);
  return !!queryResponse;
};